import { DatePipe } from '@angular/common';
import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'avmFormNullableDateValue',
    standalone: true,
})
export class AvmFormNullableDateValue implements PipeTransform {
    constructor(private datePipe: DatePipe) {}

    /**
     * Formate une valeur d'un formulaire pour afficher un tiret lorsque la valeur est vide ou nulle et que le formulaire est en read-only.
     * @param value : Valeur à formatter.
     * @param displayFormat : Format à appliquer.
     */
    transform(value: Date, displayFormat: string): string {
        if (value) {
            return this.datePipe.transform(value, displayFormat);
        } else {
            return '-';
        }
    }
}
